<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M11.6693 15.4289C13.342 13.796 13.4552 11.7036 13.6606 10.4505C14.0148 8.29031 11.6692 7.40363 9.07312 6.90052L9.4066 2.07481C9.45863 1.32197 8.86196 0.682629 8.10731 0.682617C7.44642 0.682607 6.8903 1.17759 6.81367 1.83403L6.27256 6.38801L5.08057 2.05873C4.87041 1.29544 4.07716 0.82576 3.30695 1.00856C2.53798 1.19107 2.08119 1.95537 2.28475 2.71889L3.94262 8.93701"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.44036 15.4288C2.18152 14.5281 1.82869 12.2407 1.93184 10.6432C1.99667 9.63893 2.90861 8.93945 3.91498 8.93945H7.5626C8.22096 8.93945 8.75466 9.47316 8.75466 10.1315C8.75466 10.6828 8.37664 11.1622 7.84055 11.2907L5.77574 11.7858C6.42631 11.6792 7.91234 12.3358 7.96713 13.7681"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
